import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from './authApi';

export const paymentModeApi = createApi({
  reducerPath: 'paymentModeApi',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['PaymentMode'],
  endpoints: (builder) => ({

    getPaymentModes: builder.query({
      query: () => '/payment_modes',
      providesTags: [{ type: 'PaymentMode', id: 'LIST' }],
    }),

  }),
});

export const {
  useGetPaymentModesQuery,
} = paymentModeApi;
